export default "__VITE_ASSET__BJ3wmlWh__"